module.exports = __webpack_public_path__ + "img/bg3.b0634d4c.jpg";